// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:stores` (see frontend/package.json).
// Source: agent.app.repository.managed.managed_repository_sandbox.ManagedRepositorySandbox

import { makeObservable, observable } from "mobx";
import { applyJsonPatch, JsonPatchOp } from "@/app_store/rpc/json_patch";
import { AgentTransport, callRpc } from "@/app_store/rpc/rpc";
import { registerEntity, wrapEntity } from "@/app_store/rpc/entity";
import { SandboxSessionData, SandboxSessionStore } from "./SandboxSession.generated";

export interface ManagedRepositorySandboxData {
    // Stamped onto every @observable model's dump at runtime (see
    // common._ObservableMixin._serialize_with_tag) -- tells wrapEntity which
    // generated Store class this value belongs to. Never sent by a client.
    _entity_class_name: "ManagedRepositorySandbox";
    cwd: string | null;
    sessions: Record<string, SandboxSessionData>;
}

export class ManagedRepositorySandboxStore {
    readonly _entity_class_name = "ManagedRepositorySandbox" as const;
    cwd: string | null;
    sessions: Record<string, SandboxSessionStore>;
    private _transport: AgentTransport;
    private _chainPath: string[];

    constructor(data: ManagedRepositorySandboxData, transport: AgentTransport, chainPath: string[] = []) {
        this._transport = transport;
        this._chainPath = chainPath;
        this.cwd = wrapEntity(data.cwd, transport, [...chainPath, "cwd"]) ?? null;
        this.sessions = Object.fromEntries(
            Object.entries(data.sessions ?? {}).map(([key, val]) => [
                key, wrapEntity(val, transport, [...chainPath, "sessions", key]),
            ])
        ) as Record<string, SandboxSessionStore>;
        makeObservable(this, {
            cwd: observable,
            sessions: observable,
        });
    }

    applyPatch(op: JsonPatchOp): void {
        applyJsonPatch(this, op);
    }

    async create_session(session_id?: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "create_session", [session_id], {});
    }

    async reconcile(data: Record<string, any>): Promise<any> {
        return callRpc(this._transport, this._chainPath, "reconcile", [data], {});
    }

    async destroy_session(session_id: string): Promise<any> {
        return callRpc(this._transport, this._chainPath, "destroy_session", [session_id], {});
    }
}

registerEntity("ManagedRepositorySandbox", ManagedRepositorySandboxStore);
